import { GetPersonType as PersonApiType } from 'src/api/generated/touring/types';
import { mapAddress, mapBirthdate, mapContact } from '../common';
import { mapCompanyLinkType } from '../mapCompanyLinkType';
import { PersonType } from './types';

export const mapPersonType = (apiPerson: PersonApiType): PersonType => {
  return {
    id: apiPerson.id,
    firstname: apiPerson.firstname,
    lastname: apiPerson.lastname,
    nickname: apiPerson.nickname || null,
    birthdate: mapBirthdate(apiPerson.birthdate),
    contact: mapContact(apiPerson.contact),
    address: mapAddress(apiPerson.address),
    isFreelancer: apiPerson.isFreelancer,
    isTourRep: apiPerson.isTourRep,
    colorTourRepCalendar: apiPerson.colorTourRepCalendar || null,
    notes: apiPerson.notes || null,
    userId: apiPerson.userId || null,
    companies: mapCompanyLinkType(apiPerson.companies),
  };
};
